import './default/index.vue.mjs';
import './steps/index.vue.mjs';
import './scope/index.vue.mjs';
import { register } from '../../utils/index.mjs';
export { UiInputEmits, UiInputPropsOption } from './default/index.mjs';
export { UiStepsInputEmits, UiStepsInputPropsOption } from './steps/index.mjs';
export { UiScopeInputEmits, UiScopeInputPropsOption } from './scope/index.mjs';
import _sfc_main from './default/index.vue2.mjs';
import _sfc_main$1 from './steps/index.vue2.mjs';
import _sfc_main$2 from './scope/index.vue2.mjs';

const UiInput = register.use(_sfc_main, "component");
const UiStepsInput = register.use(_sfc_main$1, "component");
const UiScopeInput = register.use(_sfc_main$2, "component");

export { UiInput, UiScopeInput, UiStepsInput, UiInput as default };
//# sourceMappingURL=index.mjs.map
